import React from "react";
import {ColoredStateIcon, StateText} from "../../../ExpertiseStatus";

const ExpertiseStatusCell = (cellData) => {
  let stateName = StateText(cellData.value);
  return (
    <div title={stateName}>
      <ColoredStateIcon stateid={cellData.value}/>
    </div>
  )
};

export default ExpertiseStatusCell;
